<div class="modal-border">
  <ion-header>
    <ion-toolbar>
      <ion-row
        ><ion-col>
          <ion-title>{{ videoData.Title }}</ion-title></ion-col
        >
        <ion-buttons>
          <ion-button (click)="dismissModal()" size="large" slot="end">
            <ion-icon name="close"></ion-icon>
          </ion-button> </ion-buttons
      ></ion-row>
    </ion-toolbar>
  </ion-header>

  <div>
    <video
      width="100%"
      height="100%"
      controls
      autoplay
      style="border-radius: 15px; margin-top: 25px"
    >
      <source [src]="videoData.Location" type="video/mp4" />
    </video>
  </div>
</div>
